import React from "react";
import { DialogContentText } from "@mui/material";
import SimpleConfirmationDialog from "../../SimpleConfirmationDialog";
import { formatDateMMDDyyyy } from "../../../util/DateUtils";
import type { CapacityReductionImpact } from "../../../types/LocationCapacitySchedule";

interface CapacityReductionWarningDialogProps {
  open: boolean;
  impact: CapacityReductionImpact | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const CapacityReductionWarningDialog = ({ open, impact, onCancel, onConfirm }: CapacityReductionWarningDialogProps) => {
  const firstDate = impact?.firstConflictDate ? formatDateMMDDyyyy(impact.firstConflictDate) : null;
  const lastDate = impact?.lastConflictDate ? formatDateMMDDyyyy(impact.lastConflictDate) : null;
  const affectedDates = firstDate && lastDate && firstDate !== lastDate ? `${firstDate} – ${lastDate}` : firstDate;

  return (
    <SimpleConfirmationDialog
      open={open}
      onClose={onCancel}
      onConfirm={onConfirm}
      title="Capacity is below your current bookings"
      body={
        <>
          <DialogContentText>
            Your new scheduled capacity is lower than your current bookings. Updating your capacity to less
            than {impact?.bookedSpaces} spaces will prevent further bookings.
          </DialogContentText>
          <DialogContentText sx={{ mt: 2 }}>
            {affectedDates && <>Affected dates: {affectedDates}. </>}
            Existing confirmed bookings won&apos;t be cancelled, and pending requests stay open for you to
            approve or decline.
          </DialogContentText>
        </>
      }
    />
  );
};

export default CapacityReductionWarningDialog;
